module.exports = __webpack_public_path__ + "static/media/mattrang.e41cd501.png";